import { useContext } from "react";
import { CalendarContext } from "../Context/CalendarContext.js";

export const useCalendarContext = () => {
  const context = useContext(CalendarContext);

  if (!context) {
    throw Error(
      "useCalendarContext must be used inside an CalendarContextProvider"
    );
  }

  return context;
};
